import { makeAutoObservable, runInAction } from 'mobx';

import type { Main } from '@app/store';

import type { CandidateAuth } from '@features/candidate-registration';

import type { AgentUser, AvailableSign, UserKind } from '../types';

type NewCandidate = Omit<CandidateAuth, 'password'>;

// Стор для хранения общей информации о юзере и данных, необходимых для первичной отрисовки приложения
export class AgentUserStore {
  private mainStore: Main;
  agent?: AgentUser;
  confirmToken?: string;
  availableSign?: AvailableSign;
  authSuccessfulText?: string;
  newCandidate?: NewCandidate;
  userKind?: UserKind;

  constructor(mainStore: Main) {
    this.mainStore = mainStore;
    makeAutoObservable(this);
  }

  setAgent = (agent: AgentUser) => {
    this.agent = { ...this.agent, ...agent };
  };

  setConfirmToken = (token: string) => {
    this.confirmToken = token;
  };

  setAvailableSign = (data: AvailableSign) => {
    this.availableSign = data;
  };
  setAuthSuccessfulText = (value: string | undefined) => {
    this.authSuccessfulText = value;
  };

  setNewCandidate = (newCandidate: NewCandidate) => {
    this.newCandidate = { ...this.newCandidate, ...newCandidate };
  };

  setUserKind = (userKind: UserKind) => {
    this.userKind = { ...userKind };
  };

  reset() {
    runInAction(() => {
      this.agent = undefined;
      this.confirmToken = undefined;
      this.availableSign = undefined;
      this.authSuccessfulText = undefined;
      this.newCandidate = undefined;
      this.userKind = undefined;
    });
  }
}
